class PromotionalBanner extends HTMLElement {
  constructor() {
    super();
    this.timer = null;
    this.options = {
      timeZone: 'America/New_York',
      hour12: false
    };
  }

  connectedCallback() {
    this.initializePromotionalBanner();
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  initializePromotionalBanner() {
    const scheduledData = this.getScheduledData();
    const now = this.getCurrentESTTime();
    const startDate = this.createDateObject(scheduledData, 'start');
    const endDate = this.createDateObject(scheduledData, 'end');

    const isActivePeriod = now >= startDate && now <= endDate;
    this.updateBannerContent(isActivePeriod ? scheduledData.scheduled_content : scheduledData.non_scheduled_content);

    this.timer = setInterval(() => {
      const currentTime = this.getCurrentESTTime();
      const isNowActive = currentTime >= startDate && currentTime <= endDate;
      
      this.updateBannerContent(isNowActive ? scheduledData.scheduled_content : scheduledData.non_scheduled_content);
      
      if (currentTime > endDate) {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  getCurrentESTTime() {
    const estTimeString = new Date().toLocaleString('en-US', this.options);
    return new Date(estTimeString);
  }

  createDateObject(data, prefix) {
    const year = data[`${prefix}_year`];
    const month = String(data[`${prefix}_month`]).padStart(2, '0');
    const day = String(data[`${prefix}_day`]).padStart(2, '0');
    const hours = String(data[`${prefix}_hours`]).padStart(2, '0');
    const minutes = String(data[`${prefix}_minutes`]).padStart(2, '0');
    
    return new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
  }

  updateBannerContent(content) {
    if (this.innerHTML !== content) {
      this.innerHTML = content;
    }
  }

  getScheduledData() {
    return JSON.parse(this.querySelector('[type="application/json"]').textContent);
  }
}

if (!customElements.get('promotional-banner')) {
  customElements.define('promotional-banner', PromotionalBanner);
}